export type Audience = 'everyone' | 'free' | 'paid'

export type EditorPublishSettings = {
  status: 'publish' | 'draft'
  scheduleAt?: string // ISO string or empty
  audience: Audience
  emailSubject: string
  shareToTwitter: boolean
  tweetText: string
  urlSlug: string
  canonicalUrl: string

  commentsEnabled: boolean
  notesEnabled: boolean
  commentsSubscriberOnly: boolean

  coverAlt: string
  autoCropLandscape: boolean
}

export const DEFAULT_EDITOR_PUBLISH_SETTINGS: EditorPublishSettings = {
  status: 'publish',
  scheduleAt: '',
  audience: 'everyone',
  emailSubject: '',
  shareToTwitter: false,
  tweetText: '',
  urlSlug: '',
  canonicalUrl: '',
  commentsEnabled: true,
  notesEnabled: false,
  commentsSubscriberOnly: false,
  coverAlt: '',
  autoCropLandscape: true,
}

